module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/bg_afce7a5aa28963ed11e3e72c2fca1fe2.png";